import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import NewTechHomePage from "@/pages/newtech/page";
import ContactPage from "@/pages/newtech/ContactPage";
import SobrePage from "@/pages/newtech/SobrePage";
import ServicosPage from "@/pages/newtech/ServicosPage";
import ProdutosPage from "@/pages/newtech/ProdutosPage";
import PortfolioPage from "@/pages/newtech/PortfolioPage";
import AdminLoginPage from "@/pages/admin/LoginPage";
import DashboardPage from "@/pages/admin/DashboardPage";
import ProdutosAdminPage from "@/pages/admin/ProdutosAdminPage";
import CategoriasAdminPage from "@/pages/admin/CategoriasAdminPage";
import ServicosAdminPage from "@/pages/admin/ServicosAdminPage";
import DepoimentosAdminPage from "@/pages/admin/DepoimentosAdminPage";
import CasesAdminPage from "@/pages/admin/CasesAdminPage";
import BannersAdminPage from "@/pages/admin/BannersAdminPage";
import ClientesAdminPage from "@/pages/admin/ClientesAdminPage";

const routes: RouteObject[] = [
  { path: "/", element: <NewTechHomePage /> },
  { path: "/sobre", element: <SobrePage /> },
  { path: "/servicos", element: <ServicosPage /> },
  { path: "/produtos", element: <ProdutosPage /> },
  { path: "/portfolio", element: <PortfolioPage /> },
  { path: "/contato", element: <ContactPage /> },
  { path: "/admin", element: <AdminLoginPage /> },
  { path: "/admin/dashboard", element: <DashboardPage /> },
  { path: "/admin/produtos", element: <ProdutosAdminPage /> },
  { path: "/admin/categorias", element: <CategoriasAdminPage /> },
  { path: "/admin/servicos", element: <ServicosAdminPage /> },
  { path: "/admin/depoimentos", element: <DepoimentosAdminPage /> },
  { path: "/admin/cases", element: <CasesAdminPage /> },
  { path: "/admin/clientes", element: <ClientesAdminPage /> },
  { path: "/admin/banners", element: <BannersAdminPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
